export default (values) => ({
  ...values,
  agent: values.agent || '',
});
